<div class="bulk-edit-condition-dialog">
  <div class="bulk-edit-condition-dialog__header">
    <h2>Add Display Conditions</h2>
    <pdq-button icon="close" variant="ghost" (onClick)="onCancel()"></pdq-button>
  </div>
  <pdq-divider></pdq-divider>

  <div class="bulk-edit-condition-dialog__content">
    <app-condition
      [formGroup]="formGroup"
      [accordionActiveSection]="accordionActiveSection"
      [loadedCarrier]="loadedCarrier"
      [hideInstructionText]="true"
      [hideAddGroupButton]="hideAddGroupButton"
      [dropdownMaxHeight]="'200'"
      [useDropdownOverlay]="true"
      (onOpenExpansionEmit)="onOpenExpansion($event)"
      (onCloseExpansionEmit)="onCloseExpansion()"
      (onExpandedNeededEmit)="onExpandedNeeded($event)">
    </app-condition>
  </div>

  <div class="bulk-edit-condition-dialog__footer">
    <pdq-button label="Cancel" variant="secondary" size="medium" (onClick)="onCancel()"> </pdq-button>
    <pdq-button
      label="Add Conditions"
      variant="primary"
      size="medium"
      [disabled]="!hasValidConditions()"
      (onClick)="onConfirm()">
    </pdq-button>
  </div>
</div>
